// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-link{color:#0073bb}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-link span{color:#0073bb}#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-link svg{height:16px;width:16px}#awsccc-sb-ux-c #awsccc-sb-a .dark-mode-enabled .awsccc-u-link{color:#44b9d6}#awsccc-sb-ux-c #awsccc-sb-a .dark-mode-enabled .awsccc-u-link span{color:#44b9d6}", ""]);
// Exports
module.exports = exports;
